import { useMutation, useQueryClient } from "@tanstack/vue-query";
import Note from "@/services/note";

/**
 * Composable for deleting a note
 */
export function useDeleteNote() {
  const queryClient = useQueryClient();

  const deleteMutation = useMutation({
    mutationFn: async (noteId: string) => {
      const result = await Note.deleteNote(noteId);
      if (!result.data.status) {
        throw new Error(result.data.msg || "Failed to delete note");
      }
      return result.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["notes"] });
    },
  });

  return {
    deleteNote: deleteMutation.mutateAsync,
    isDeleting: deleteMutation.isPending,
    deleteError: deleteMutation.error,
  };
}
